import { EditIcon } from 'assets/images/svg';
import React, { useState } from 'react';
import GrantPermissionsToGroupModal from 'zComponents/molecules/GrantPermissionsToGroupModal';
import { Button, Col, Row } from 'zui/Antd';

const PermissionPanelExtra = ({ groupID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = (e) => {
		e.stopPropagation();
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('Permissions')) {
			setActiveKeys([...activeKeys, 'Permissions']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('Permissions')) {
					return [...prev, 'Permissions'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Button type='text' icon={<EditIcon />} onClick={handleOpenModal} />
				<GrantPermissionsToGroupModal visible={openModal} setVisible={handleCloseModal} groupID={groupID}>
					<div />
				</GrantPermissionsToGroupModal>
			</Col>
		</Row>
	);
};

export default PermissionPanelExtra;
